import { toggleFavouriteProperty } from '../services/favourite_property.service';

const ADD_TO_FAVOURITES = 'ADD_TO_FAVOURITES';
const REMOVE_FROM_FAVOURITES = 'REMOVE_FROM_FAVOURITES';
const ADDED_TO_FAVOURITES = 'ADDED_TO_FAVOURITES';
const REMOVED_FROM_FAVOURITES = 'REMOVED_FROM_FAVOURITES';

const events = [
  ADD_TO_FAVOURITES,
  ADDED_TO_FAVOURITES,
  REMOVE_FROM_FAVOURITES,
  REMOVED_FROM_FAVOURITES,
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(ADD_TO_FAVOURITES, ({ id, csrfToken }) => {
    const onError = (err) => console.warn(err);
    const displayStatus = (response) => {
      const acceptedStatuses = [201];
      if (acceptedStatuses.includes(response.status)) {
        EVENT_BUS.dispatch(ADDED_TO_FAVOURITES, { id });
      }
    };

    toggleFavouriteProperty({
      id,
      csrfToken,
      eventType: 'add',
      onResponse: displayStatus,
      onError,
    });
  });

  EVENT_BUS.on(REMOVE_FROM_FAVOURITES, ({ id, csrfToken }) => {
    const onError = (err) => console.warn(err);
    const displayStatus = (response) => {
      const acceptedStatuses = [200];
      if (acceptedStatuses.includes(response.status)) {
        EVENT_BUS.dispatch(REMOVED_FROM_FAVOURITES, { id });
      }
    };

    toggleFavouriteProperty({
      id,
      csrfToken,
      eventType: 'remove',
      onResponse: displayStatus,
      onError,
    });
  });
};

export const FAVOURITES_EVENTS = {
  initializeEventListeners,
  ADD_TO_FAVOURITES,
  ADDED_TO_FAVOURITES,
  REMOVE_FROM_FAVOURITES,
  REMOVED_FROM_FAVOURITES,
};
